import callback1 from "../../../utils/prototypeDefinitions/Date.prototype.addDays";
callback1();

export const toMonthDateAndMonthNumber = (date) => {
  const shrinkMonth = date.getMonth() + 1;
  const month = shrinkMonth >= 10 ? shrinkMonth : '0' + shrinkMonth;

  return `${date.getDate()}.${month}`;
};

export const toBeautifullText = (date) => {
  const now = new Date();

  if (date.getMonth() === now.getMonth() && date.getDate() === now.getDate()) {
    return "Сьогодні";
  } else if (
    date.addDays(-1).getMonth() === now.getMonth() &&
    date.addDays(-1).getDate() === now.getDate()
  ) {
    return "Завтра";
  } else if (
    date.addDays(-2).getMonth() === now.getMonth() &&
    date.addDays(-2).getDate() === now.getDate()
  ) {
    return "Післязавтра";
  } else {
    return toMonthDateAndMonthNumber(date);
  }
};

export const toWeekDay = (date) =>
  ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"][
    date.getDay()
  ];
